import React from 'react';
import {
  useNavigate, useLocation, useParams
} from 'react-router-dom';

// You should only use this in legacy React class components.
// This was added as a workaround so that we can upgrade to React Router v6
// and still use React class components.
const withRouter = (Component) => {
  const ComponentWithRouterProp = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();

    return (
      <Component
        {...props}
        {...{
          location, params, navigate
        }}
      />
    );
  };

  return ComponentWithRouterProp;
};

export default withRouter;
